import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UserContext from "../context/UserContext";
import Explanations from "../components/ThreatFeeds/Explanations";
import Register from "../components/ThreatFeeds/Register";
import Registered from "../components/ThreatFeeds/Registered";
import Spinner from "../components/base/Spinner";
import Header from "../components/base/Header";

const FeedService = () => {
  const [pending, setPending] = useState(false)
  const { loading, user } = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (
      typeof user === "object" &&
      !Array.isArray(user) &&
      user !== null
    ) {
      navigate("/profile");
    }
    // eslint-disable-next-line
  }, []);

  return (
    <main>
      <section className="eindhoven-background-image">
        <div className="boxes">
          <Explanations />
          {pending ? <Registered /> : <Register setPending={setPending} />}
        </div>
      </section>
      {loading && <Spinner />}
    </main>
  );
};

export default FeedService;
